<input
  class="aca-date-input__field"
  type="text"
  autocomplete="off"
  size="10"
  [attr.id]="inputId()"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-invalid]="invalid() || null"
  [placeholder]="placeholder() ?? ('DMS.DATE_INPUT.PLACEHOLDER' | translate)"
  [formControl]="control"
  [matDatepicker]="picker"
  [min]="minDate()"
  [max]="maxDate()"
  (dateChange)="onDateChange($event)"
  (blur)="onTouched()"
/>
<button
  type="button"
  class="aca-date-input__toggle"
  [disabled]="control.disabled"
  [attr.aria-label]="'DMS.DATE_INPUT.OPEN_CALENDAR' | translate"
  (click)="picker.open()"
>
  <mat-icon class="aca-date-input__icon" aria-hidden="true">calendar_today</mat-icon>
</button>
<mat-datepicker #picker (closed)="onTouched()" />
